import { JSX, ParentComponent, splitProps } from "solid-js";

const FormGroup: ParentComponent<JSX.HTMLAttributes<HTMLDivElement>> = (
  props
) => {
  const [local, attributes] = splitProps(props, ["children", "class"]);
  return (
    <div class={`form-group ms-3 mb-3 ${local.class ?? ""}`} {...attributes}>
      {props.children}
    </div>
  );
};
export default FormGroup;
